import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { FormsModule, ReactiveFormsModule,Validators } from '@angular/forms';
import { ValidateEqualModule } from 'ng-validate-equal';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { AuthenticationService } from './_services/index';
import { JwtInterceptor } from './_helper/index';
import {ActiveGuard} from './_guards/index';
import { NxIconRegistry, DEFAULT_ICONS } from "@aposin/ng-aquila/icon";

import { SearchComponent } from './search/search.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
// used to create fake backend
import { fakeBackendProvider } from './_helper/index';
import { HeaderComponent } from './header/header.component';
import { CaseDialogComponent } from './case-dialog/case-dialog.component';
import { FooterComponent } from './footer/footer.component';
import { ErrorComponent } from './error/error.component';
import * as AngularWebStorageModule from 'angular-web-storage';
import { QuickLinksComponent } from './quick-links/quick-links.component';
import { HelpTopicsComponent } from './help-topics/help-topics.component';
import { LandingComponent } from './landing/landing.component';
// import { TooltipModule } from 'ng2-tooltip-directive';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { SearchResultComponent } from './search-result/search-result.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgxSpinnerModule } from "ngx-spinner";
import { HelpCenterComponent } from './help-center/help-center.component';
import { ViewArticlesComponent } from './view-articles/view-articles.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { PwdresetEmailComponent } from './pwdreset-email/pwdreset-email.component';
import { ModifyPasswordComponent } from './modify-password/modify-password.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowseComponent } from './browse/browse.component';
import { ArticleViewComponent } from './article-view/article-view.component';
import { KbArticlesComponent } from './kb-articles/kb-articles.component';
import { SearchArticlesComponent } from './search-articles/search-articles.component';
import { SurveyCreationComponent } from './survey-creation/survey-creation.component';
import { NotificationComponent } from './notification/notification.component';
import { ChatUserInterfaceComponent } from './chat-user-interface/chat-user-interface.component';
import { SsoLoginComponent } from './sso-login/sso-login.component';
import { RouterModule } from '@angular/router';
import { NgHcaptchaModule } from 'ng-hcaptcha';
import { environment } from '../environments/environment';
import { NgInit, CustomDateAdapter } from './create-ticket/create-ticket.component';
import { TrackerComponent } from './tracker/tracker.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MaterialModule } from './material.module';

@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    HomeComponent,
    LoginComponent,
    ForgotpasswordComponent,
    HeaderComponent,
    FooterComponent,
    ErrorComponent,
    QuickLinksComponent,
    HelpTopicsComponent,
    LandingComponent,
    SearchResultComponent,
    HelpCenterComponent,
    PasswordresetComponent,
    PwdresetEmailComponent,
    ViewArticlesComponent,
    CreateTicketComponent,
    ModifyPasswordComponent,
    BrowseComponent,
    ArticleViewComponent,
    KbArticlesComponent,
    SearchArticlesComponent,
    SurveyCreationComponent,
    NotificationComponent,
    ChatUserInterfaceComponent,
    SsoLoginComponent,
    NgInit,
    CustomDateAdapter,
    TrackerComponent,
    CaseDialogComponent
  ],

  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    // FlexLayoutModule,
    ReactiveFormsModule,
    // AngularWebStorageModule,
    // TooltipModule,
    AutocompleteLibModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    MatCardModule,
    NgbModule,
    MatButtonModule,
    // ValidateEqualModule,
    MatExpansionModule,
    NgHcaptchaModule.forRoot({
      siteKey: environment.captcha.siteKey,
      languageCode:environment.captcha.languageCode
  }),
  
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AuthenticationService,
    ActiveGuard,
    Title,
    // providers used to create fake backend
    fakeBackendProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
  ],
  // entryComponents: [CaseDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
